import PropTypes from 'prop-types';
import { COLOR_THEMES } from '@karma/components/themes';
import Modal from 'components/templates/Modal/Modal';
import * as ALOOMA from 'consts/alooma';
import ModalBodyLoyaltyForm from 'components/molecules/ModalBodyLoyaltyForm/ModalBodyLoyaltyForm';

const ModalLoyaltyForm = props => {
  const { closeModal } = props;

  return (
    <Modal
      source={ALOOMA.SOURCE_PAGES.EMBEDDED_LOYALTY}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      aloomaModalName={ALOOMA.MODAL_NAMES.LOYALTY_FORM}
      onClose={closeModal}
      colorTheme={COLOR_THEMES.LIGHT}
    >
      <ModalBodyLoyaltyForm {...props} />
    </Modal>
  );
};

ModalLoyaltyForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default ModalLoyaltyForm;
